
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVoiceResend = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#voice-resend_041ae2921c418766__a)",
  fill: "#423F45"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.826 12.848a.716.716 0 0 0-1.431 0c0 3.5-2.848 6.349-6.349 6.349a6.356 6.356 0 0 1-6.349-6.35.716.716 0 0 0-1.431 0c0 4.05 3.108 7.385 7.064 7.748v1.927H8.674a.716.716 0 1 0 0 1.431h6.744a.716.716 0 0 0 0-1.431h-2.656v-1.927c3.956-.362 7.064-3.698 7.064-7.747Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.046 17.43a4.588 4.588 0 0 0 4.583-4.582V4.536a4.588 4.588 0 0 0-4.583-4.583 4.588 4.588 0 0 0-4.583 4.583v8.312a4.588 4.588 0 0 0 4.583 4.583ZM8.894 4.537a3.155 3.155 0 0 1 3.152-3.151 3.155 3.155 0 0 1 3.151 3.15v8.313a3.155 3.155 0 0 1-3.151 3.151 3.155 3.155 0 0 1-3.152-3.151V4.536Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "voice-resend_041ae2921c418766__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_8631_157080)\">\r\n<path d=\"M19.8265 12.8477C19.8265 12.4525 19.5061 12.1321 19.1107 12.1321C18.7154 12.1321 18.395 12.4525 18.395 12.8477C18.395 16.3486 15.547 19.1967 12.046 19.1967C8.54517 19.1967 5.69715 16.3486 5.69715 12.8477C5.69715 12.4525 5.37671 12.1321 4.98139 12.1321C4.58606 12.1321 4.26562 12.4525 4.26562 12.8477C4.26562 16.8967 7.3744 20.2323 11.3302 20.5949V22.5217H8.67408C8.27876 22.5217 7.95832 22.8421 7.95832 23.2374C7.95832 23.6328 8.27876 23.9532 8.67408 23.9532H15.4181C15.8132 23.9532 16.1336 23.6328 16.1336 23.2374C16.1336 22.8421 15.8132 22.5217 15.4181 22.5217H12.7617V20.5949C16.7177 20.2325 19.8265 16.8967 19.8265 12.8477Z\" fill=\"#423F45\"/>\r\n<path d=\"M12.0459 17.4306C14.573 17.4306 16.6289 15.3747 16.6289 12.8476V4.5359C16.6289 2.00904 14.573 -0.046875 12.0459 -0.046875C9.51905 -0.046875 7.46313 2.00904 7.46313 4.5359V12.8476C7.46313 15.3747 9.51905 17.4306 12.0459 17.4306ZM8.89447 4.5359C8.89447 2.79822 10.3082 1.38465 12.0459 1.38465C13.7836 1.38465 15.1973 2.79822 15.1973 4.5359V12.8476C15.1973 14.5853 13.7836 15.9991 12.0459 15.9991C10.3082 15.9991 8.89447 14.5853 8.89447 12.8476V4.5359Z\" fill=\"#423F45\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_8631_157080\">\r\n<rect width=\"24\" height=\"24\" fill=\"white\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/voice-resend.041ae2921c418766aea250058c025075.svg"),
        {
          React: SvgVoiceResend,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      